import { useState, useRef, useEffect } from 'react';
import styles from './ForkModal.module.css';

export default function ForkModal({ onFork, onClose }) {
  const [text, setText] = useState('');
  const textareaRef = useRef(null);

  useEffect(() => {
    textareaRef.current?.focus();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (text.trim()) {
      onFork(text.trim());
    }
  };

  return (
    <div className={styles.backdrop} onClick={onClose}>
      <div className={styles.dialog} onClick={e => e.stopPropagation()}>
        <h2 className={styles.heading}>Fork conversation</h2>
        <form onSubmit={handleSubmit}>
          <textarea
            ref={textareaRef}
            className={styles.textarea}
            rows={3}
            value={text}
            onChange={e => setText(e.target.value)}
            placeholder="Take the conversation in a new direction..."
          />
          <div className={styles.actions}>
            <button type="button" className={styles.cancelBtn} onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className={styles.forkBtn} disabled={!text.trim()}>
              Fork
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
